import React, { useState, useEffect } from 'react'
import './home.scss'
import Footer from '../../components/Footer/Footer'
import HeroHeader from './HeroHeader'
import SBNav from '../../shared/components/SideBarNav/SBNav'

const roomActions = [
    {
        title: 'Upload and Create',
        text: 'Upload almost any file type, or create editable code and text files directly inside the room.',
        icon: 'file-upload-l.png',
    },
    {
        title: 'Add Folders',
        text: 'Add or upload folders to stay organized, then download entire projects as convenient ZIP files.',
        icon: 'folder-upload-l.png',
    },
    {
        title: 'Collaborate',
        text: 'Share code, notes, and reusable text that room members can open, edit, and work from together.',
        icon: 'numusers3.png',
    },
    {
        title: 'Download Fast',
        text: 'Download or copy the files and resources you need without digging through emails, links, or shared drives.',
        icon: 'download-icon.png',
    },
    {
        title: 'Manage Your Room',
        text: 'Manage room permissions, control who can contribute, and moderate shared content to keep collaboration running smoothly.',
        icon: 'settings-dark.png',
    },
    {
        title: 'Invite Members',
        text: 'Share a simple join code so students, teammates, or collaborators can enter the room in seconds.',
        icon: 'share-icon.png',
    },
]

function Home() {


    useEffect(() => {
        document.title = 'FlashRoom'
    }, [])

    const [nav, openNav] = useState(false);

    useEffect(() => {
        if (!nav) {
            // ensure cleanup if nav is false
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }




        // --- lock scroll (keeps current scroll position) ---
        const scrollY = window.scrollY;

        // add blur class to <html> (we'll define CSS below)
        document.documentElement.classList.add("nav-blur");

        // lock body in place
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            // --- restore ---
            document.documentElement.classList.remove("nav-blur");

            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);



    return (
        <div id='home'>


            <div id='header-block'>

                <div className='nav-2'>
                    <div className='nav-logo-container'>
                        <img src={`${process.env.PUBLIC_URL}/images/flashroom-logo-light.png`} height="44px" alt='FlashRoom logo' />
                        <h1>Flash<span>Room</span></h1>
                    </div>


                    <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                        <div />
                        <div />
                        <div />
                    </div>

                </div>



                <HeroHeader />

            </div>





            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>


            <section id='how-to-start'>

                <div className='hts-card'>
                    <span className='hts-num'>1</span>
                    <img src={`${process.env.PUBLIC_URL}/images/room-icon.png`} alt='file icon' width='45px' />
                    <h2>Create Room</h2>

                    <p>Simply create a room right from here</p>
                </div>

                <div className='hts-card'>
                    <span className='hts-num'>2</span>
                    <img src={`${process.env.PUBLIC_URL}/images/add-folder-l.png`} alt='file icon' width='40px' />
                    <h2>Add files</h2>

                    <p>Add in files or snippets of text or code</p>
                </div>

                <div className='hts-card'>
                    <span className='hts-num'>3</span>
                    <img src={`${process.env.PUBLIC_URL}/images/enter-code.png`} alt='file icon' height='35px' />
                    <h2>Entrance Code</h2>

                    <p>flash-room.com/join and enter in code</p>
                </div>



                <div className='hts-card'>
                    <span className='hts-num'>4</span>
                    <img src={`${process.env.PUBLIC_URL}/images/share-icon.png`} alt='file icon' width='40px' />

                    <h2>Share</h2>

                    <p>Instantly share starter code, text, links, and files</p>
                </div>

            </section>

            <section className='home-action-deck' aria-label='What you can do in FlashRoom'>
                <div
                    className='home-action-deck__art'
                    style={{ backgroundImage: `linear-gradient(90deg, rgba(13, 20, 34, 0.98), rgba(13, 20, 34, 0.58) 48%, rgba(13, 20, 34, 0.9)), url('${process.env.PUBLIC_URL}/images/cbb4.png')` }}
                    aria-hidden='true'
                />

                <div className='home-action-deck__header'>
                    <p className='home-kicker'>Room tools</p>
                    <h2>Everything you need to share files and collaborate in one room.</h2>
                    <p>
                        FlashRoom makes it easy to upload files, create editable content, organize resources,
                        share code and notes, invite participants, and download everything from one simple workspace.
                    </p>
                </div>

                <div className='home-action-grid'>
                    {roomActions.map((action) => (
                        <div className='home-action-card' key={action.title}>
                            <div className='home-action-icon'>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/${action.icon}`}
                                    alt=''
                                    aria-hidden='true'
                                />
                            </div>

                            <div>
                                <h3>{action.title}</h3>
                                <p>{action.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>




            <section className='home-showcase-band' aria-label='FlashRoom workspace highlights'>
                <div className='home-showcase-copy'>
                    <p className='home-kicker'>Built around the room</p>
                    <h2>Everything feels connected because everything lives together.</h2>
                    <p>
                        FlashRoom is not just a file drop. It gives a class, club, or team a shared table:
                        the code, the files, the people, and the next action all stay in view.
                    </p>
                </div>

                <div className='home-showcase-grid'>
                    <div className='showcase-metric'>
                        <strong>One Place</strong>
                        <span>Keep files, code, notes, and people together</span>
                    </div>
                    <div className='showcase-metric'>
                        <strong>Less Setup</strong>
                        <span>Skip complicated accounts, tools, and workflows</span>
                    </div>
                    <div className='showcase-metric'>
                        <strong>Stay Moving</strong>
                        <span>Share, edit, and download without cutting into class time</span>
                    </div>
                </div>
            </section>






            <section className='home-about-cards' aria-label='Why FlashRoom works'>


                <div className='home-about-card' id='home-description'>

                    <div className='headshot-cont'>
                        <img src={`${process.env.PUBLIC_URL}/images/snippet-pic.png`} alt='sharing icon' />
                    </div>



                    <div className='has-content'>
                        <h2>Sharing Made <span>Easy</span></h2>

                        <p>Instantly share files, code, and links in under 30 seconds.
                            Create a room, send a code, and everyone joins in seconds.
                            No accounts, no setup, no friction. </p>

                    </div>
                </div>



                <div className='home-about-card' id='abt-teachers'>

                    <div className='headshot-cont'>
                        <img src={`${process.env.PUBLIC_URL}/images/classroom2.png`} alt='sharing icon' />
                    </div>



                    <div className='has-content'>
                        <h2>Built for Classrooms and <span>Teams</span></h2>

                        <p>Bring everyone into a shared space without the hassle.
                            Perfect for lessons, demos, and real-time collaboration.
                            Stay organized while everyone stays in sync.</p>

                    </div>
                </div>

                <div className='home-about-card' id='home-about-section'>


                    <div className='headshot-cont'>
                        <img src={`${process.env.PUBLIC_URL}/images/simple3.png`} alt='Simple workspace illustration' />
                    </div>

                    <div className='has-content'>
                        <h2>Simple but <span>Versatile</span></h2>

                        <p>A clean, focused, and intuitive interface makes FlashRoom easy for teachers and students to jump into. Share files with hundreds of students, collaborate in small groups, or quickly transfer a PDF from one device to another, all without unnecessary setup.
                        </p>
                    </div>
                </div>

            </section>


            <Footer />





        </div>
    )
}

export default Home
